import { useCallback, useEffect } from "react"
import { useSocketProvider } from "../../../../../Providers/SocketProvider"
import { D3TimeBasedVisualization } from "../Components/Visualizations/D3TimeBasedVisualization"
import { CheckRecordingInfoResponse } from "./useCheckRecordingInfo"

type D3UpdateRecordingInfoProps = {
    d3Controller?: D3TimeBasedVisualization<any, any, any, any>
}

export const useD3UpdateRecordingInfo = ({ d3Controller }: D3UpdateRecordingInfoProps) => {
    const { getDataQuerySocket } = useSocketProvider()

    const handleSocketResponse = useCallback((socketResponse: CheckRecordingInfoResponse) => {
        if (socketResponse.error) {
            return
        }
        d3Controller?.updateRecordingInfo(socketResponse)
    }, [d3Controller])

    useEffect(() => {
        const socket = getDataQuerySocket()
        socket.on("check_recording_info", handleSocketResponse)

        return () => {
            socket.off("check_recording_info", handleSocketResponse)
        }
    }, [getDataQuerySocket, handleSocketResponse])
}
